import React from 'react';

import SidebarPAFilter from './productAttributes/sidebarPAFilter';

import '../../../../css/filter.css';

export default function SidebarFilter(props) {
	const {
		customAttributeMap,
		displayAttribute,
		displaySplitFields,
		filterValues,
		filterAttributes,
		handleFilterClick,
		productAttributes,
		currency,
		setCustomAttributeMap,
		showTriggerButton,
		width,
		filter,
		handleFilterChange,
		enableFilter,
		handleFilterNumericChange,
		resetFilter,
		sortCb,
		callback,
		pageActiveCallback,
		searchParams,
		searchComponents
	} = props;

	let filterStandardAttributes = displaySplitFields && productAttributes && productAttributes.standardAttributes
		? productAttributes.standardAttributes.filter((attribute) => !attribute.isSearchable)
		:		productAttributes.standardAttributes;

	filterStandardAttributes = filterStandardAttributes.filter((attribute) => attribute.attributeType === 'Multi_Picklist' || attribute.attributeType === 'Picklist' || attribute.attributeType === 'Numeric' || attribute.attributeType === 'Currency' || attribute.attributeType.toLowerCase() === 'decimal');

	return (
		<SidebarPAFilter
			customAttributeMap={customAttributeMap}
			displayAttribute={displayAttribute}
			handleFilterClick={handleFilterClick}
			productAttributes={{ standardAttributes: filterStandardAttributes, customAttributes: productAttributes.customAttributes }}
			setCustomAttributeMap={setCustomAttributeMap}
			callback={callback}
			pageActiveCallback={pageActiveCallback}
			searchParams={searchParams}
			showTriggerButton={showTriggerButton}
			searchComponents={searchComponents}
			filterAttributes={filterAttributes}
			filterValues={filterValues}
			currency={currency}
			filter={filter}
			sortCb={sortCb}
			handleFilterChange={handleFilterChange}
			handleFilterNumericChange={handleFilterNumericChange}
			enableFilter={enableFilter}
			resetFilter={resetFilter}
			width={width}
		/>
	);
}
